import API from 'shared/constants/api';
import { generateUrl } from 'shared/helpers/urls';
import { getPriceValueBySlug } from 'shared/helpers/transportInfo';

import { execPostRequest } from './utils';

export const prepareParamsForCreditMarketRequest = params => ({
  advertId: params.id,
  city: params.location && params.location.title,
  year: params.year,
  name: params.userName,
  make: params.make && params.make.title,
  model: params.model && params.model.title,
  phone: params.phone,
  sum: Math.round(getPriceValueBySlug(params.price, 'uah')),
  url: generateUrl(params),
});

export const sendCreditMarket = async (params, fetch) =>
  execPostRequest(API.ADVERT.CREDIT_MARKET.ADD, params, fetch);



// WEBPACK FOOTER //
// ./src/shared/helpers/leasing/creditmarket.js